import {
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OrderService, SplitService } from '@tabify/core/services';

@Component({
  imports: [RouterModule],
  selector: 'tabi-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly matIconReg = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly router = inject(Router);
  private readonly orderService = inject(OrderService);
  private readonly splitService = inject(SplitService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.registerCustomIcons();
    this.setupRouteChangeListener();
  }

  private registerCustomIcons(): void {
    // Social media icons
    this.matIconReg.addSvgIcon(
      'instagram',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '/icons/social-media/instagram.svg',
      ),
    );
    this.matIconReg.addSvgIcon(
      'facebook',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '/icons/social-media/facebook.svg',
      ),
    );

    // Flag icons for language selector
    this.matIconReg.addSvgIcon(
      'flag-gb',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/icons/flags/gb.svg'),
    );
    this.matIconReg.addSvgIcon(
      'flag-no',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/icons/flags/no.svg'),
    );
  }

  private setupRouteChangeListener(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        const url = event.urlAfterRedirects;

        // Clear state when navigating to info page or transactions page
        if (/^\/orders\/[^/]+\/info/.test(url)) {
          this.orderService.groupId.set(null);
          this.splitService.resetSplitConfig();
          this.splitService.reset();
          this.orderService.clearSelectedItems();
        } else if (/^\/transactions\//.test(url)) {
          this.clearOrderState();
        }
      });
  }

  private clearOrderState(): void {
    this.orderService.reset();
    this.orderService.clearSelectedItems();
    this.splitService.resetSplitConfig();
    this.splitService.reset();
  }
}
